import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template181: Consejos SF - bloques desde page (header, intro, tips: icon + text, imagen opcional)
const Template181 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const isSmallScreen = useWindowSize().width <= 600;
	const contentColor = textColor || "#444";

	const headerText =
		page.texts?.[0]?.content ?? "Consejos útiles para San Francisco";
	const introText = page.texts?.[1]?.content ?? "";
	const tips = Array.isArray(page.tips)
		? page.tips
		: Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
				? page.data.data.tips
				: [];
	const getImageSrc = (id) =>
		page.images?.find((img) => img.id === id)?.src ?? "";
	const tipBox =
		page?.tipBox ?? page?.data?.tipBox ?? page?.data?.data?.tipBox ?? {};
	const tipImageId = tipBox.imageId ?? "frio-sf";
	const tipImageSrc = getImageSrc(tipImageId);

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100vh",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: headerBackgroundColor || "#F2B705",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
			</Box>

			{/* ——— Intro ——— */}
			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
				}}
			>
				{tips.map((tip, index) => (
					<Box
						key={index}
						data-block-id={`text-${index + 3}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #fbf0cf",
							marginBottom: index === 0 ? "0px" : 0,
						}}
					>
						<Box sx={{ fontSize: 18 }}>{tip.icon ?? ""}</Box>
						<Box
							sx={{
								fontSize: 13,
								color: contentColor,
								marginRight: index === 0 ? 3 : 0,
							}}
						>
							{typeof tip.text === "string" ? tip.text : (tip.text ?? "")}
						</Box>
					</Box>
				))}
				{tipImageSrc && (
					<Box
						component="img"
						src={tipImageSrc}
						alt="tips"
						sx={{
							width: isSmallScreen ? 80 : 90,
							position: "absolute",
							top: isSmallScreen ? 40 : 30,
							right: -20,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template181.thumbnail = "/images/template-1.png";
export default Template181;
